<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Recipients List">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-between pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-select
                  *appHasPlatformAccess
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
                <app-input-template
                  (keyup)="applyFilter()"
                  [inputData]="attrConstant.search"
                  [formControlName]="
                    attrConstant.search.key
                  "></app-input-template>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
              <div class="d-flex align-items-center gap-10">
                <img
                  src="assets/images/reload.svg"
                  alt="reload"
                  class="reload-img"
                  matTooltip="Reload"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="reload()" />
                <button class="btn primary-btn" (click)="export()">
                  Export
                </button>
                <button class="btn primary-btn" (click)="openReport()">
                  Report
                </button>
              </div>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Recipient No. Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Recipient No.
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Recipient No.">
                  {{ element.bene_id }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="bene_first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element" data-label="Name">
                  {{ element.bene_first_name }} {{ element.bene_last_name }}
                </td>
              </ng-container>

              <!-- Country Column -->
              <ng-container matColumnDef="benificiary_country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Country
                </th>
                <td mat-cell *matCellDef="let element" data-label="Country">
                  {{ element.benificiary_country }}
                </td>
              </ng-container>

              <!-- Mobile No. Column -->
              <ng-container matColumnDef="bene_mobile_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Mobile No.
                </th>
                <td mat-cell *matCellDef="let element" data-label="Mobile No.">
                  {{ element.bene_mobile_number }}
                </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Created Date
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Created Date">
                  {{ element.created_at | date: 'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container *appHasAccess="'/recipient/edit/:id'">
                    Action
                  </ng-container>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Action"
                  (click)="$event.stopPropagation()">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="right"
                      [routerLink]="[
                        '/recipient/edit',
                        isSuperAdmin
                          ? element.bene_id + '-' + element.partner_id
                          : element.bene_id,
                      ]"
                      *appHasAccess="'/recipient/edit/:id'" />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="onDeleteRecipient(element)"
                      *appHasAccess="'/recipient/edit/:id'" />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="let row; columns: displayedColumns; let element"
                [routerLink]="[
                  '/recipient/details',
                  isSuperAdmin
                    ? element.bene_id + '-' + element.partner_id
                    : element.bene_id,
                ]"></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)"></mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'/recipient/add'">
        <ng-template mat-tab-label>
          <a [routerLink]="['/recipient/add']" class="btn primary-btn">
            Add Recipient
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
